module.exports = __webpack_public_path__ + "img/cup_off.eb6cda26.svg";